<h1 i18n>Home</h1>
<p i18n>
    Welcome to “Futures of AI-Impacted Teaching and Learning: Perceptions and Imaginaries from Students: A Pilot Project”. The data you submit will only be made available for research by academic and
    professional individuals and organisations.
    <a [routerLink]="['/', 'privacy']">Learn more about how we protect your privacy</a>.
</p>
<a class="btn btn-primary btn-lg" [routerLink]="['/', 'submission']">
    <span i18n>Make submission</span>&nbsp;
    <fa-icon [icon]="faArrowRight" aria-hidden="true"></fa-icon>
</a>
@if (!(languageService.disableLanguageToggle$ | async)) {
<p class="mt-2">
    <a class="icon-link" (click)="toggleLanguage()">
        <fa-icon [icon]="faGlobe" />
        <span i18n lang="nl" i18n-lang="Target language code">Schakel naar het Nederlands</span>
    </a>
</p>
}
